import { render, staticRenderFns } from "./AIStudyTips.vue?vue&type=template&id=1619cb41&"
import script from "./AIStudyTips.vue?vue&type=script&lang=js&"
export * from "./AIStudyTips.vue?vue&type=script&lang=js&"
import style0 from "./AIStudyTips.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports